export default "__VITE_ASSET__DoQIibkj__"